import { takeLatest } from "redux-saga/effects";
import * as WORKERS from "../workers/kitchens";
import { KITCHENS_GET_REQUEST_ACTION } from "../../actions/kitchens";

export function* watchSaga() {
  yield takeLatest(KITCHENS_GET_REQUEST_ACTION, WORKERS.getKitchensData);
}
